import { handleRetrieveBookings } from "../../../../redux/admin-slices/webinars.slice"
import TablePagination from "../../../../components/common/PaginationSkell"
import EntriesSelect from "../../../../components/ui/EntriesSelect"
import TableSkell from "../../../../components/common/TableSkell"
import InputFieldA from "../../../../components/ui/InputFieldA"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useRef, useState } from "react"
import { debounce } from "../../../../utils/helper"
import { useParams } from "react-router-dom"

import {
  Box, Container, Grid2 as Grid, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Typography
} from "@mui/material"

function Bookings() {
  const { id } = useParams()
  const searchRef = useRef("")
  const entriesRef = useRef("")
  const dispatch = useDispatch()
  const [data, setData] = useState({})
  const { refresh, loadings } = useSelector(state => state.otherSlice)

  // Handle retrieve all FAQs
  const handleRetrieveAll = (filters) => {
    dispatch(handleRetrieveBookings({
      id,
      search: searchRef?.current?.value || null,
      limit: entriesRef?.current?.value || null,
      currentPage: filters?.currentPage || null,
    })
    ).unwrap().then((data) => {
      setData(data)
    }).catch(() => { })
  }

  // Handle search FAQs
  const handleSearch = debounce(() => {
    handleRetrieveAll()
  }, 1000)

  useEffect(() => {
    handleRetrieveAll()

    // eslint-disable-next-line
  }, [refresh])

  return (
    <Container maxWidth={false} fixed sx={{ py: 5 }}>
      <Box className="overview-container">
        <Typography variant="pageTitle">Webinar Bookings</Typography>
      </Box>

      <Grid container spacing={1} className="filters-grid" justifyContent="space-between">
        <Grid size={{ xs: 12, sm: 8, lg: "auto" }} sx={{ minWidth: { xl: 350 } }}>
          <InputFieldA
            label="Search"
            ref={searchRef}
            onChangeFun={handleSearch}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4, lg: "auto" }}>
          <EntriesSelect
            inputRef={entriesRef}
            label="Entries per page"
            onChange={() => {
              setTimeout(() => {
                handleRetrieveAll()
              }, 0)
            }}
          />
        </Grid>
      </Grid>

      <Box className="content-listing">
        <TableContainer className="adminTable1">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {["Name", "Email"]?.map((cell, i) => (
                  <TableCell key={i} align="left">{cell}</TableCell>
                ))
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {loadings?.retrieveAll ?
                <TableSkell colLength={2} /> :
                data?.records?.map((element, i) => (
                  <TableRow
                    key={i}
                    tabIndex={-1}
                    role="checkbox"
                    sx={{ "td": { borderBottomWidth: i === (data?.records?.length - 1) ? "0" : "1px" } }}
                  >
                    <TableCell sx={{ textTransform: "capitalize" }}>{element?.member?.fullName}</TableCell>
                    <TableCell>{element?.member?.email}</TableCell>
                  </TableRow>
                ))
              }

              {(!data?.records?.length && !loadings?.retrieveAll) &&
                <TableRow sx={{ "td": { borderBottom: "none" } }}>
                  <TableCell colSpan={2}>
                    <Typography variant="noRecords">No results found!</Typography>
                  </TableCell>
                </TableRow>
              }
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          pagination={data?.pagination}
          length={data?.records?.length}
          loading={loadings?.retrieveAll}
          cb={handleRetrieveAll}
          limit={entriesRef?.current?.value || 10}
        />
      </Box>
    </Container>
  )
}

export default Bookings